import BaseComponent from "../../../baseComponent.js";

export default class TimeLine extends BaseComponent {
  constructor(props) {
    super(props);
    this.playInterval = null;
    this.model = {};
    if (props.default == null) {
      this.model.defaultValue = 0;
    }
  }

  componentDidMount() {
    var time = this.props.time;
    $('#globe-timeline').rangeslider({
      polyfill: false,
      onSlide: (position, value) => {
        this.publish("crude-oil-time-changed", value);
        $('#timeline-current-label').text(time[value]);
      },
      onSlideEnd: function (position, value) {
      }
    });

    $('.rangeslider__handle').append('<div id="timeline-current-label">' + this.props.time[0] + '</div>');
    $('#timeline-current-label').css({
      'position': 'absolute',
      'top': '-25px',
      'left': '20px',
      'font-size': 'large',
      'color': '#f24235',
      'width': '500px',
      'text-align': 'center',
      'transform': 'translate(-50%, 0)',
      '-webkit-transform': 'translate(-50%, 0)',
      '-moz-transform': 'translate(-50%, 0)',
      '-ms-transform': 'translate(-50%, 0)'
    });
  }

  componentWillUnmount() {
    $('#globe-timeline').rangeslider('destroy');
  }

  onPlayBtnClick() {
    var timeline = $('#globe-timeline');
    var time = this.props.time;
    if (this.playInterval == null) {
      // if timeline is already at the end, set it to the beginning
      if (timeline.val() == time.length - 1) {
        timeline.val(0).change();
      }

      this.playInterval = setInterval(() => {
          var currentValue = timeline.val();
          var newValue = ++currentValue;
          if (newValue == time.length - 1) {
            clearInterval(this.playInterval);
            this.playInterval = null;

            $('#timeline-play-button').removeClass('fa-pause').addClass('fa-play');
          }
          timeline.val(newValue).change();
        }, 600);

      $('#timeline-play-button').removeClass('fa-play').addClass('fa-pause');
    }
    else {
      clearInterval(this.playInterval);
      this.playInterval = null;

      $('#timeline-play-button').removeClass('fa-pause').addClass('fa-play');
    }
  }

  render() {
    var wrapperStyle = {
      position: 'absolute',
      bottom: '-40px',
      left: '50%',
      transform: 'translate(-50%, 0)',
      WebkitTransform: 'translate(-50%, 0)',
      MozTransform: 'translate(-50%, 0)',
      MsTransform: 'translate(-50%, 0)',
      width: '60vw',
      margin: '0 auto',
      marginTop: '2rem',
      zIndex: '1'
    };

    var playStyle = {
      position: 'relative',
      left: '50%',
      transform: 'translate(-50%, 0)',
      WebkitTransform: 'translate(-50%, 0)',
      MozTransform: 'translate(-50%, 0)',
      MsTransform: 'translate(-50%, 0)',
      color: '#f24235',
      marginTop: '15px',
      cursor: 'pointer',
      fontSize: '50px'
    };

    var startLabel = {
      position: 'absolute',
      top: '37px',
      left: '0px',
      fontSize: 'large',
      color: '#b8b8b8',
      transform: 'translate(-50%, 0)',
      WebKitTransform: 'translate(-50%, 0)',
      MozTransform: 'translate(-50%, 0)',
      MsTransform: 'translate(-50%, 0)'
    };

    var endLabel = {
      position: 'absolute',
      top: '37px',
      right: '0px',
      fontSize: 'large',
      color: '#b8b8b8',
      transform: 'translate(50%, 0)',
      WebKitTransform: 'translate(50%, 0)',
      MozTransform: 'translate(50%, 0)',
      MsTransform: 'translate(50%, 0)'
    };

    return (
      <div style={wrapperStyle}>
        <input id="globe-timeline" type="range" min="0" max={this.props.time.length - 1} step="1" defaultValue="0"/>
        <i id="timeline-play-button" className="material-icons" style={playStyle} onClick={this.onPlayBtnClick}>play_arrow</i>
        <div style={startLabel}>{this.props.time[0]}</div>
        <div style={endLabel}>{this.props.time[this.props.time.length - 1]}</div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/globe/crude-oil/timeline.jsx